import React, { useState } from "react";
import { useWorldContract } from "../../../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import setEntityMetadata from "../../systemCalls/handleSetEntityMetadata";
import { EveButton } from "@eveworld/ui-components";
import { useNotification } from "@eveworld/contexts";
import { Stack, TextField } from "@mui/material";

interface ButtonProps {
  AssemblyId: string;
  NewName: string;
  NewDappUrl: string;
  NewDescription: string;
}

const ButtonEditInfo: React.FC<ButtonProps> = ({
  AssemblyId,
  NewName,
  NewDappUrl,
  NewDescription,
}) => {
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();
  const [inputNameValue, setInputNameValue] = useState(NewName);
  const [inputDappUrlValue, setInputDappUrlValue] = useState(NewDappUrl);
  const [inputDescriptionValue, setInputDescriptionValue] =
    useState(NewDescription);

  const handleChangeName = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setInputNameValue(event.target.value);
  };

  const handleChangeDappUrl = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setInputDappUrlValue(event.target.value);
  };

  const handleChangeDescription = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setInputDescriptionValue(event.target.value);
  };

  const handleEditInfo = async (
    SmartObjectId: string,
    NewName: string,
    NewDappUrl: string,
    NewDescription: string
  ) => {
    const txHash = await setEntityMetadata({
      worldContract,
      smartObjectId: SmartObjectId,
      newName: NewName,
      newDappUrl: NewDappUrl,
      newDescription: NewDescription,
    });
    if (txHash) {
      notify({ type: Severity.Success, txHash });
    } else {
      notify({
        type: Severity.Error,
        message: "Transaction failed to execute",
      });
    }
  };

  return (
    <Stack direction={"row"} spacing={1}>
      <TextField
        label="New Name"
        variant="outlined"
        value={inputNameValue}
        onChange={handleChangeName}
      />
      <TextField
        label="New Dapp URL"
        variant="outlined"
        value={inputDappUrlValue}
        onChange={handleChangeDappUrl}
      />
      <TextField
        label="New Description"
        variant="outlined"
        value={inputDescriptionValue}
        onChange={handleChangeDescription}
      />
      <EveButton
        typeClass="primary"
        onClick={() =>
          handleEditInfo(
            AssemblyId,
            inputNameValue,
            inputDappUrlValue,
            inputDescriptionValue
          )
        }
      >
        Update Info
      </EveButton>
    </Stack>
  );
};

export default React.memo(ButtonEditInfo);
